export enum TabName {
  all = 'all',
  inCart = 'inCart',
  quotation = 'quotation',
  // paid = 'paid',
  shipping = 'shipping',
  delivered = 'delivered',
  canceled = 'canceled',
  order = 'order',
}
